const BUCKET_ROOT = 'https://shoobphoto.s3.us-west-1.amazonaws.com/assets/graphics/Seniors';

export const CURSIVE_BASE_URL = `${BUCKET_ROOT}/${encodeURIComponent('Cursive_Announcement.jpg')}`;
export const CURSIVE_OVERLAY_URL = `${BUCKET_ROOT}/${encodeURIComponent('Cursive_Announcement_Overlay.png')}`;

export function extractScodeFromPoseUrl(url) {
  if (!url) return null;
  const filename = url.split('?')[0].split('/').pop() || '';
  const match = filename.match(/^(\d+)-[es]/i);
  return match ? String(parseInt(match[1], 10)) : null;
}

export function announcementThumbUrlForScode(scode) {
  if (!scode) return null;
  const filename = `${scode}_Traditional Logo Announcement.jpg`;
  return `${BUCKET_ROOT}/${encodeURIComponent(filename)}`;
}

export function announcementThumbUrlForPose(url) {
  return announcementThumbUrlForScode(extractScodeFromPoseUrl(url));
}
